import { SERVER_URL } from "../constants/Api";
import client from "./httpClient";

const baseUrl = `${SERVER_URL}/self_registration/resend_email_otp`;

export const resendOtp = async ({ email, accountId, type }) => {
  const res = await client
    .post(baseUrl, {
      json: {
        email: email,
        verification_type: type,
        account_id: accountId
      }
    })
    .json();
  return res;
};
